import React, { useEffect, useRef, useState } from 'react';
import { Box, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { alpha } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ExpandableSearch = () => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const searchContainerRef = useRef(null);
  const history = useHistory();
  const { t } = useTranslation();

  const handleToggleSearch = () => {
    setShowSearch(prev => !prev);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && searchValue.trim()) {
      history.push(`/search?q=${encodeURIComponent(searchValue.trim())}`);
      setShowSearch(false);
      setSearchValue('');
    }
  };

  const handleClickOutside = e => {
    if (searchContainerRef.current && !searchContainerRef.current.contains(e.target)) {
      setShowSearch(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Box display="flex" alignItems="center" mr={2} ref={searchContainerRef}>
      <IconButton
        onClick={handleToggleSearch}
        size="large"
        sx={{
          color: theme => alpha(theme.palette.common.white, 0.38),
          '&:hover, &:focus': {
            color: theme => theme.palette.common.white,
          },
        }}>
        <SearchIcon />
      </IconButton>
      <Box
        sx={{
          width: showSearch ? { xs: 150, sm: 220, md: 300 } : 0,
          opacity: showSearch ? 1 : 0,
          overflow: 'hidden',
          transition: 'all 0.3s ease',
          ml: showSearch ? 1 : 0,
        }}>
        {showSearch && (
          <InputBase
            placeholder={t('searchFor')}
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus={showSearch}
            sx={{
              height: 40,
              px: 2,
              backgroundColor: theme => alpha(theme.palette.common.white, 0.15),
              color: 'white',
              fontFamily: 'Trade Gothic LT bdC',
              width: '100%',
              '& .MuiInputBase-input': {
                color: 'white !important',
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default ExpandableSearch;
